import ImagePath from "app/utilities/imagePath";

export interface ISideBar {
    name: string;
    image: string;
    activeImage: string;
    path: string;
    pathname: string;
}

export const sidebarItem: ISideBar[] = [
    {
        name: 'Dashboard',
        image: ImagePath.portofolioGray.src,
        activeImage: ImagePath.portofolioWhite.src,
        path: '/dashboard/porto',
        pathname: '/dashboard',
    },
     {
        name: 'Marketplace',
        image: ImagePath.marketplaceGray.src,
        activeImage: ImagePath.marketplaceWhite.src,
        path: '/marketplace/list',
        pathname: '/marketplace'
    }
];
